import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3",
  id: "content_screen"
}
const _hoisted_2 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('p-3 flex content-main gap-5')
}
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg px-[32px] max-w-full py-[16px]" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.vg_selectedLocation.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-[24px] text-white font-semibold mb-3" }, "Insights and Reports", -1)),
              _createElementVNode("iframe", {
                src: _ctx.locationIframe,
                width: "100%",
                height: "1400px"
              }, null, 8, _hoisted_5)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
              _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.")
            ])
          ], -1)
        ]))]))
  ]))
}